import ShimmerScreen from "../../../Layouts/ShimmerScreen"
import "./DetailPageDescComponent.scss"

const DetailPageDescComponent = ({ desc, isLoading }) => {
    return (
        <>
        {
            isLoading ?
            <>
                {
                    [0,20,40].map((t, i) => {
                        return (
                            <div className={`${i > 0 ? 'mt-2' : ''}`}>
                                <ShimmerScreen 
                                    case="rect"
                                    width={`${80-t}%`}
                                    height="1rem"
                                />
                            </div>
                        )
                    })
                }
            </>
            :
            <div className="page-desc"
                dangerouslySetInnerHTML={{
                    __html: desc
                }}
            >
            </div>
        }
        </>
    )
}

export default DetailPageDescComponent